import { User } from "@/common/models/User";
import { httpService } from "@/common/services/HttpService";

class UAUserService {
  async getUsers(searchTerm: string): Promise<User[]> {
    const { data } = await httpService
      .getInstance()
      .get<User[]>("/api/v1/backoffice/admin/users", { params: { searchTerm } });
    return data;
  }
}

export const userService = new UAUserService();
